var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "element-config-dialog",
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("CargoMsg.Cargo_ElementSettings"),
        width: "600px",
        "close-on-click-modal": false
      },
      on: { close: _vm.handleCancel }
    },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_ElementRules"),
                name: "rules"
              }
            },
            [
              _c("div", { staticClass: "element-rules" }, [
                _c(
                  "div",
                  { staticClass: "rule-options" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          checked: _vm.isReadOnlyElement(_vm.element),
                          disabled: _vm.isDefaultReadOnlyElement(_vm.element)
                        },
                        model: {
                          value: _vm.form.isReadonly,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "isReadonly", $$v)
                          },
                          expression: "form.isReadonly"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_IsReadOnly")) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        attrs: { disabled: _vm.element.isDefaultRequire },
                        model: {
                          value: _vm.form.isRequire,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "isRequire", $$v)
                          },
                          expression: "form.isRequire"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_IsRequired")) +
                            " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }